import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DialogComponent } from './dialog.component';
import { InsertionPointDirective } from './directives/insertion-point.directive';
import { DialogToggle } from './model/dialog-toggle';



@NgModule({
  declarations: [
    DialogComponent,
    InsertionPointDirective
  ],
  imports: [
    BrowserAnimationsModule
  ],
  exports: [
    DialogComponent
  ],
  providers: [
    {
      provide: DialogToggle, useClass: DialogToggle
    }
  ]
})
export class DialogModule { }
